import { gql } from '@apollo/client';

export const UPDATE_QUIZ = gql`
  mutation UpdateQuiz(
    $id: ID!,
    $isTeamReportApproved: Boolean!,
    $aiReportData: JSONObject
  ) {
    updateQuiz(
      id: $id,
      isTeamReportApproved: $isTeamReportApproved,
      aiReportData: $aiReportData
    ) {
      id
      isTeamReportApproved
      aiReportData
      reportUrl
    }
  }
`;
